exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header__container___-6BaX {\n  padding: 18px 0;\n  border-bottom: solid 1px #dbdbdb;\n  display: flex;\n  justify-content: space-between; }\n  .header__container___-6BaX .header__title___1evPF {\n    font-size: 20px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    color: #3f3f3f; }\n  .header__container___-6BaX .header__closeButton___3AUQS {\n    border: none;\n    background-color: #fff;\n    font-size: 20px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    text-align: right;\n    color: #828282; }\n", ""]);

// exports
exports.locals = {
	"container": "header__container___-6BaX",
	"title": "header__title___1evPF",
	"closeButton": "header__closeButton___3AUQS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/Header/header.scss
// module id = 4539
// module chunks = 6